import generate from 'firebase-auto-ids'
import firebase from 'firebase'
import { ref, storageRef } from 'constants/firebase'
import * as _ from 'lodash'

function * uploadFileSimple (path, file) {
  try {
    // console.log('uploadFileSimple', path, file)
    const snapshot = yield storageRef.child(path).put(file)
    // console.log('uploadFileSimple, return downloadURL', snapshot.downloadURL)
    return snapshot.downloadURL
  } catch (e) {
    console.error('uploadFileSimple error', path, file, e)
    return null
  }
}

export function uploadToStorageVideo (appId, videofile, imagefile) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    const imagefileId = generate(_.now())
    const videofileId = generate(_.now())
    try {
      const videoPath = `users/${userId}/${videofileId}`
      const videoUrl = yield uploadFileSimple(videoPath, videofile)
      // console.log('videoUrl', videoUrl)

      const imagePath = `users/${userId}/${imagefileId}`
      const imageUrl = yield uploadFileSimple(imagePath, imagefile)
      // console.log('imageUrl', imageUrl)

      const assetInfo = {
        id: videofileId,
        name: videofile.name,
        url: videoUrl,
        uploadedAt: firebase.database.ServerValue.TIMESTAMP,
        type: 'video',
        thumb: {
          id: imagefileId,
          url: imageUrl
        }
      }

      if (videofile.width) assetInfo.width = videofile.width
      if (videofile.height) assetInfo.height = videofile.height

      ref.child('users').child(userId).child('apps').child(appId).child('assets').child(videofileId).set(assetInfo)
    } catch (e) {
      console.error('upoading video file error', e)
    }
  }
}

export function * uploadImageSimple (userId, file, fileId = generate(_.now())) {
  try {
    const imagePath = `users/${userId}/${fileId}`
    const imageUrl = yield uploadFileSimple(imagePath, file)
    // console.log('imageUrl', imageUrl)

    const assetInfo = {
      id: fileId,
      name: file.name,
      url: imageUrl,
      uploadedAt: firebase.database.ServerValue.TIMESTAMP,
      type: 'image',
      size: file.size
    }

    if (file.width) assetInfo.width = file.width
    if (file.height) assetInfo.height = file.height

    return assetInfo

  } catch (e) {
    console.error('upoading image file error', e)
    return null
  }
}


export function uploadToStorage (appId, file, fId = null, onCompleted = () => null) {
  return function * (dispatch, getState) {
    const fileId = _.isNil(fId) ? generate(_.now()) : fId
    // console.log('uploadToStorage', file)
    const state = getState()
    const userId = state.authData.id
    const assetInfo = yield uploadImageSimple(userId, file, fileId)
    if (assetInfo) {
      yield ref.child('users').child(userId).child('apps').child(appId).child('assets').child(fileId).set(assetInfo)
      onCompleted(assetInfo)
    }
  }
}

export function * removeFromStorageSimple (userId, appId, fileId) {
  // console.log('removeFromStorageSimple', userId, appId, fileId)
  try {
    storageRef.child('users').child(userId).child(fileId).delete()
  } catch (e) {
    console.warn('The image has been already deleted from storage')
  }
  yield ref.child('users').child(userId).child('apps').child(appId).child('assets').child(fileId).set(null)
}

export function removeFromStorage (appId, fileId) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    yield removeFromStorageSimple(userId, appId, fileId)
  }
}



// WEBPACK FOOTER //
// ./src/controllers/storage.js